import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { WorkOS } from '../_models/workOS.model';
import { QueryParamsModel } from '../../_base/crud';

export enum WorkOSActionTypes {
  AllWorkOSsRequested = '[WorkOSs Module] All WorkOSs Requested',
  AllWorkOSsLoaded = '[WorkOSs API] All WorkOSs Loaded',
  WorkOSOnServerCreated = '[Edit WorkOS Component] WorkOS On Server Created',
  WorkOSCreated = '[Edit WorkOS Dialog] WorkOS Created',
  WorkOSOnServerUpdated = '[Edit WorkOS Dialog] WorkOS On Server Updated',
  WorkOSUpdated = '[Edit WorkOS Dialog] WorkOS Updated',
  WorkOSsPageRequested = '[WorkOSs List Page] WorkOSs Page Requested',
  WorkOSsPageLoaded = '[WorkOSs API] WorkOSs Page Loaded',
  WorkOSsPageCancelled = '[WorkOSs API] WorkOSs Page Cancelled',
  WorkOSsPageToggleLoading = '[WorkOSs] WorkOSs Page Toggle Loading',
  WorkOSsActionToggleLoading = '[WorkOSs] WorkOSs Action Toggle Loading',
  ThrowWorkOSError = '[WorkOSs] Throw Error',
  FireWorkOSSuccess = '[WorkOSs] Fire Success',
}

export class WorkOSOnServerCreated implements Action {
  readonly type = WorkOSActionTypes.WorkOSOnServerCreated;
  constructor(public payload: { workOS: WorkOS }) {}
}

export class WorkOSCreated implements Action {
  readonly type = WorkOSActionTypes.WorkOSCreated;
  constructor(public payload: { workOS: WorkOS }) {}
}

export class ThrowWorkOSError implements Action {
  readonly type = WorkOSActionTypes.ThrowWorkOSError;
  constructor(public payload: { error: any }) {}
}

export class FireWorkOSSuccess implements Action {
  readonly type = WorkOSActionTypes.FireWorkOSSuccess;
  constructor(public payload: { action_type: string }) {}
}

export class WorkOSOnServerUpdated implements Action {
  readonly type = WorkOSActionTypes.WorkOSOnServerUpdated;
  constructor(
    public payload: {
      partialWorkOS: Update<WorkOS>;
      workOS: WorkOS;
    },
  ) {}
}

export class WorkOSUpdated implements Action {
  readonly type = WorkOSActionTypes.WorkOSUpdated;
  constructor(
    public payload: {
      partialWorkOS: Update<WorkOS>;
      workOS: WorkOS;
    },
  ) {}
}

export class WorkOSsPageRequested implements Action {
  readonly type = WorkOSActionTypes.WorkOSsPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class WorkOSsPageLoaded implements Action {
  readonly type = WorkOSActionTypes.WorkOSsPageLoaded;
  constructor(public payload: { workOSs: WorkOS[]; totalCount: number; page: QueryParamsModel }) {}
}

export class WorkOSsPageCancelled implements Action {
  readonly type = WorkOSActionTypes.WorkOSsPageCancelled;
}

export class WorkOSsPageToggleLoading implements Action {
  readonly type = WorkOSActionTypes.WorkOSsPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class WorkOSsActionToggleLoading implements Action {
  readonly type = WorkOSActionTypes.WorkOSsActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export type WorkOSActions =
  | WorkOSCreated
  | WorkOSUpdated
  | WorkOSOnServerCreated
  | WorkOSOnServerUpdated
  | WorkOSsPageLoaded
  | WorkOSsPageCancelled
  | WorkOSsPageToggleLoading
  | WorkOSsPageRequested
  | ThrowWorkOSError
  | FireWorkOSSuccess
  | WorkOSsActionToggleLoading;
